import React, { Component } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import MenuOptions from '../../../../Misc/MenuOptions/menuOptions';
import { getReportMenuOptions } from '../../../../Misc/MenuOptions/menuOptionsActions';
import { MealTypesReports, MenuOrderTypes, currency_symbol, date_format } from '../../../../../server/constants';
import { get } from '../../../../../server/actions';
import { _addNotificationError, groupBy, isRegularLunchOrderType, showFile, getSchoolGrades, convertTwoDecimalPoint } from '../../../../../server/util'
import DateTimeRangePicker from '../../../../Misc/DateTimeRangePicker';
import TmExportExcel from '../../../../Misc/tmExportExcel/tmExportExcel';
class OrderCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            summary: {},
            summarySearch: '',
            details: [],
            detailsSearch: '',
            mealType: (getReportMenuOptions()[0] || ''),
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            selectedGrade: ''
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.setState({ mealType: '' }, () => {
            this.getOrdersReport(this.state.startDate, this.state.endDate);
        });
    }
    getOrdersReport = (startDate, endDate, isPdf = false) => {
        this.setState({ loading: true });
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        const _gradeStr = this.state.selectedGrade === '' ? '' : '&grade=' + this.state.selectedGrade;
        const url = `/reports/orderCostReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}&isExport=${isPdf}&menuType=${this.state.mealType}${_gradeStr}&access_token=`
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            if (isPdf) {
                return response.blob();
            } else {
                return response.json();
            }
        }).then(data => {
            if (isPdf) {
                let filename = `Order Cost-${this.state.mealType}`;
                showFile(data, filename);
                this.setState({
                    loading: false,
                })
            } else {

                this.setState({
                    summary: data.costByGrade || {},
                    details: (data.response || []).map(item => {
                        item.displayOrder = ((gradeGroup[item.grade] || [])[0] || {}).displayOrder || ''
                        item.gradeText = ((gradeGroup[item.grade] || [])[0] || {}).label || ''
                        return item
                    }),
                    loading: false
                })
            }
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Loading Report Failed", error)
        })
    }
    onChangeDateRange = (startDate, endDate) => {
        let _startDate = startDate;
        let _endDate = endDate;
        this.setState({ startDate: _startDate, endDate: _endDate }, () => {
            this.getOrdersReport(_startDate, _endDate)
        })
    }
    buildFormatForExport = () => {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        const gradeByStudentsGroup = groupBy((this.state.details || []), 'grade');
        const filterList = (this.state.details || []).filter(item => {
            if (this.state.selectedGrade == '') {
                return true;
            } else {
                return item.grade === this.state.selectedGrade;
            }
        })
        let summaryData = [];
        let result = [];
        summaryData = Object.keys(this.state.summary).map(key => {
            return {
                grade: key,
                gradeText: ((gradeGroup[key] || [])[0] || {}).label || '',
                displayOrder: ((gradeGroup[key] || [])[0] || {}).displayOrder || '',
                cost: this.state.summary[key],
                studentsCount: (gradeByStudentsGroup[key] || []).length
            }
        }).sort((a, b) => {
            return a.displayOrder - b.displayOrder
        }).filter(obj => {
            if (this.state.summarySearch.length <= 0) {
                return true;
            }
            if ((obj.gradeText + '').includes(this.state.summarySearch)) {
                return true;
            } else {
                return false;
            }
        });

        result.push(
            {
                columns: ["Grade", "Students Count", "Cost"],
                data: summaryData.map(item => {
                    return [item.gradeText, item.studentsCount, `${currency_symbol()} ${convertTwoDecimalPoint(item.cost)}`]
                })
            }
        );
        result.push(
            {
                columns: ["Student Id", "First Name", "Last Name", "Grade", "Student Id", "Date", "Cost"],
                data: (filterList || []).filter(obj => {
                    const s = this.state.detailsSearch;
                    if (s.length <= 0) {
                        return true
                    } else {
                        if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                            return true
                        } else if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                            return true
                        } else if (obj.lastName != null && (obj.lastName.toLowerCase() + ' ' + obj.firstName.toLowerCase()).startsWith(s.toLowerCase())) {
                            return true
                        } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                            return true
                        } else {
                            return false;
                        }
                    }
                }).sort((a, b) => {
                    return a.displayOrder - b.displayOrder
                }).map(item => {
                    return [
                        item.studentId,
                        item.firstName,
                        item.lastName,
                        ((gradeGroup[item.grade] || [])[0] || {}).label || '',
                        item.studentId,
                        `${moment(item.date, 'YYYY-MM-DD').format(date_format())}`,
                        `${currency_symbol()} ${convertTwoDecimalPoint(item.cost)}`
                    ]
                })
            }
        );
        return result;
    }

    render() {
        const gradeGroup = groupBy(getSchoolGrades(0, false), 'value');
        const gradeByStudentsGroup = groupBy((this.state.details || []), 'grade');
        const filterList = (this.state.details || []).filter(item => {
            if (this.state.selectedGrade == '') {
                return true;
            } else {
                return item.grade === this.state.selectedGrade;
            }
        })
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="pull-right" style={{ display: 'inline-block', marginLeft: '50px' }}>
                            <MenuOptions menuOptionsList={getReportMenuOptions()} isAll={true}
                                onOptionSelect={(type) => {
                                    this.setState({ mealType: (type === 'All' ? '' : type) },
                                        () => {
                                            this.getOrdersReport(this.state.startDate, this.state.endDate);
                                        })
                                }}
                                selectedOption={(this.state.mealType === '' ? 'All' : this.state.mealType)} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'white',
                            padding: '3px',
                            margin: '5px',
                            float: 'right',
                            borderRadius: '3px',
                            fontSize: '25px'
                        }}>
                            <DateTimeRangePicker
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                applyCallback={(event, picker) => {
                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                }}
                                isDateShow={false}
                            />
                        </div>
                        <div style={{
                            display: 'inline-block',
                            backgroundColor: 'transparent',
                            float: 'right',
                            borderRadius: '3px'
                        }}>
                            <div className="btn-group">
                                <button className="btn-link btn-sm dropdown-toggle" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{ color: '#fff', fontSize: '13px' }}>
                                    <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                                </button>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a title="Click to Download PDF" style={{ cursor: 'pointer' }}
                                            onClick={() => { this.getOrdersReport(this.state.startDate, this.state.endDate, true); }}
                                            target='_blank'>
                                            <i className="fa fa-file-pdf-o" /> Pdf</a>
                                    </li>
                                    <li>
                                        <TmExportExcel id="orderCostReportt"
                                            name={"Order Cost Report"}
                                            filename={"Order Cost Report"}
                                            element={<a title="Click to Download Excel" id="orderCostReportt"
                                                style={{
                                                    display: 'block',
                                                    padding: '3px 20px',
                                                    clear: 'both',
                                                    fontWeight: '400',
                                                    lineHeight: 1.42857143,
                                                    color: '#333',
                                                    whiteSpace: 'nowrap',
                                                    cursor: 'pointer'
                                                }}
                                            ><i className="fa fa-file-excel-o" /> Excel</a>}
                                            dataSet={this.buildFormatForExport()}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="panel panel-p1 panel-primary">
                            <div className="panel-heading text-center">
                                <h3 className="panel-title">{`Order Cost Report ${this.state.startDate.format(date_format())} - ${this.state.endDate.format(date_format())}`}</h3>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-md-4 text-center">
                                        <h4 style={{ padding: '5px 0px 0px 10px', fontWeight: '700', textTransform: 'none' }}>Cost Summary</h4>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="col-md-12 text-center">
                                            <h4 style={{ padding: '5px 0px 0px 10px', fontWeight: '700', textTransform: 'none' }}>
                                                {this.state.selectedGrade == '' ? `Cost Details` : `Cost Details Of Grade: ${((gradeGroup[this.state.selectedGrade] || [])[0] || {}).label || ''}`}</h4>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <ReactTable
                                                    data={Object.keys(this.state.summary).map(key => {
                                                        return {
                                                            grade: key,
                                                            gradeText: ((gradeGroup[key] || [])[0] || {}).label || '',
                                                            displayOrder: ((gradeGroup[key] || [])[0] || {}).displayOrder || '',
                                                            cost: this.state.summary[key],
                                                            studentsCount: (gradeByStudentsGroup[key] || []).length
                                                        }
                                                    }).sort((a, b) => {
                                                        return a.displayOrder - b.displayOrder
                                                    }).filter(obj => {
                                                        if (this.state.summarySearch.length <= 0) {
                                                            return true;
                                                        }
                                                        if ((obj.gradeText + '').includes(this.state.summarySearch)) {
                                                            return true;
                                                        } else {
                                                            return false;
                                                        }
                                                    })}
                                                    columns={[{
                                                        Header: "Grade",
                                                        width: 70,
                                                        style: { textAlign: 'left' },
                                                        Cell: (props) => {
                                                            return <span >{props.original.gradeText}</span>
                                                        }
                                                    },
                                                    {
                                                        Header: "Students Count",
                                                        style: { textAlign: 'center' },
                                                        Cell: (props) => {
                                                            return <span>{props.original.studentsCount}</span>
                                                        }
                                                    },
                                                    {
                                                        Header: "Cost",
                                                        width: 100,
                                                        Cell: (props) => {
                                                            return <span>{`${currency_symbol()} ${convertTwoDecimalPoint(props.original.cost)}`}</span>
                                                        }
                                                    }]}
                                                    defaultPageSize={12}
                                                    className="-striped -highlight rtTable-Order"
                                                    noDataText='No data found'
                                                    showPagination={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-md-12 form-group">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <input className="form-control" placeholder="Search..." type="text"
                                                            value={this.state.detailsSearch}
                                                            onChange={(e) => {
                                                                this.setState({ detailsSearch: e.target.value })
                                                            }} />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <select className="form-control" value={this.state.selectedGrade} onChange={(e) => {
                                                            this.setState({ selectedGrade: e.target.value }, () => {
                                                                this.getOrdersReport(this.state.startDate, this.state.endDate);
                                                            });
                                                        }}>
                                                            <option value="">All</option>
                                                            {
                                                                Object.keys(gradeGroup || {}).map(key => {
                                                                    return <option value={key}>{((gradeGroup[key] || [])[0] || {}).label || ''}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <ReactTable
                                                    data={(filterList || []).filter(obj => {
                                                        const s = this.state.detailsSearch;
                                                        if (s.length <= 0) {
                                                            return true
                                                        } else {
                                                            if (obj.studentId != null && (obj.studentId.toLowerCase()).startsWith(s.toLowerCase())) {
                                                                return true
                                                            } else if (obj.firstName != null && (obj.firstName.toLowerCase() + ' ' + obj.lastName.toLowerCase()).startsWith(s.toLowerCase())) {
                                                                return true
                                                            } else if (obj.lastName != null && (obj.lastName.toLowerCase() + ' ' + obj.firstName.toLowerCase()).startsWith(s.toLowerCase())) {
                                                                return true
                                                            } else if (obj.pin != null && (obj.pin.toLowerCase()).startsWith(s.toLowerCase())) {
                                                                return true
                                                            } else {
                                                                return false;
                                                            }
                                                        }
                                                    }).sort((a, b) => {
                                                        return a.displayOrder - b.displayOrder
                                                    })}
                                                    columns={
                                                        [
                                                            {
                                                                Header: "First Name",
                                                                Cell: (props) => {
                                                                    return <span>{`${props.original.firstName || ''}`}</span>
                                                                }
                                                            },
                                                            {
                                                                Header: "Last Name",
                                                                Cell: (props) => {
                                                                    return <span>{`${props.original.lastName || ''}`}</span>
                                                                }
                                                            },
                                                            {
                                                                Header: 'Grade',
                                                                Cell: (props) => {
                                                                    return <span>{((gradeGroup[props.original.grade] || [])[0] || {}).label || ''}</span>
                                                                },
                                                                show: this.state.selectedGrade == '' ? true : false

                                                            },
                                                            {
                                                                Header: "Student Id",
                                                                accessor: 'studentId'
                                                            },
                                                            {
                                                                Header: "Pin",
                                                                accessor: 'pin'
                                                            },
                                                            {
                                                                Header: "Date",
                                                                Cell: (props) => {
                                                                    return <span>{`${moment(props.original.date, 'YYYY-MM-DD').format(date_format())}`}</span>
                                                                }
                                                            },
                                                            {
                                                                Header: "Cost",
                                                                width: 150,
                                                                Cell: (props) => {
                                                                    return <span >{`${currency_symbol()} ${convertTwoDecimalPoint(props.original.cost)}`}</span>
                                                                }
                                                            }
                                                        ]}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight rtTable-Order"
                                                    noDataText='No data found'
                                                    showPagination={true} />
                                            </div>
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderCost;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/Orders/orderCost.jsx